import { storageProvider } from '@ocean/configs'

class LegacyUtils {
  clearStaNotifications() {
    storageProvider.removeItem('sta-NotificationControlRefresher-splash')
    storageProvider.removeItem('sta-NotificationControlRefresher')
  }
}

export default new LegacyUtils()
